import React, { useState, useEffect } from 'react';
import '../css/project.css';
import '../css/tabs.css';
import '../css/moodboard-grid.css';
import session from '../services/session';
import Tour from 'reactour';
import { Redirect } from 'react-router-dom';
import moment from "moment";
import {
    swalDeleteForm,
    swalError,
    swalSuccess,
    swalInfo,
    swalUploading,
    swalConfirm, swalRenameTab, swalUploadingWithProgress
} from "../utils/swal";
import projectService from "../services/project";
import moodboardService from "../services/moodboard";
import tabService from "../services/tab";
import storyboardService from "../services/storyboard";
import scriptService from "../services/script";
import Swal from 'sweetalert2';
import bgImgSrc from '../images/new-project-background.jpg';
import { Container, Button, Link } from 'react-floating-action-button';
import LocalHospitalOutlinedIcon from '@material-ui/icons/LocalHospitalOutlined';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import BackspaceIcon from '@material-ui/icons/Backspace';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import TabIcon from '@material-ui/icons/Tab';
import ClearIcon from '@material-ui/icons/Clear';
import WebIcon from '@material-ui/icons/Web';
// import {
//     FloatingMenu,
//     MainButton,
//     ChildButton,
// } from 'react-floating-button-menu';
import MdAdd from '@material-ui/icons/Add';
import MdClose from '@material-ui/icons/Clear';
import ViewQuiltOutlinedIcon from "@material-ui/icons/ViewQuiltOutlined";
import ViewModuleOutlinedIcon from "@material-ui/icons/ViewModuleOutlined";
import ViewListOutlinedIcon from "@material-ui/icons/ViewListOutlined";
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import InstagramIcon from '@material-ui/icons/Instagram';
import ShareIcon from "@material-ui/icons/Share";
import Moodboard from './Moodboard';
import Storyboard from './Storyboard';
import UploadAndViewVendorFiles from './UploadAndViewVendorFiles';
import EditorMaterialSlate from './EditorMaterialSlate';
import SyncingEditorMaterialSlate from './SyncingEditorMaterialSlate';
import Embed from './Embed';
import EmbedInstagram from './EmbedInstagram';
import EmbedWebsite from "./EmbedWebsite";
import Pexels from './Pexels';
import MoodboardMasonry from './MoodboardMasonry';
import MoodboardTiles from './MoodboardTiles';
import Collaborate from './Collaborate';
import ContentDetails from './ContentDetails';
import MoodboardMediaView from './MoodboardMediaView';
import Avatar from 'react-avatar';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import { uuid } from 'uuidv4';


export default function N(props) {

    // const [isOpen, setIsOpen] = useState(false);
    const [showPexels, setShowPexels] = useState(false);
    const [showEmbed, setShowEmbed] = useState(false);
    const [showEmbedInstagram, setShowEmbedInstagram] = useState(false);
    const [showWebsite, setShowWebsite] = useState(false);
    const [showCollaborate, setShowCollaborate] = useState(false);
    const [redirectTo, setRedirectTo] = useState(null);
    const [displayType, setDisplayType] = useState('grid');
    const [project, setProject] = useState(null);
    const [moodboardOrder, setMoodboardOrder] = useState(1);
    const [viewCommentsFor, setViewCommentsFor] = useState(null);
    const [isTourOpen, setIsTourOpen] = useState(false);
    const [activeTabId, setActiveTabId] = useState(null);
    const [tabMoodboards, setTabMoodboards] = useState(null);
    const [progress, setProgress] = useState(0);
    const steps = [
        {
            selector: '.action-button-selector',
            content: 'Add new items onto your board.',
            style: {
                backgroundColor: '#000000',
            },
        },
        {
            selector: '.share-button-selector',
            content: 'Share this board with others by inviting them or sharing a link.',
            style: {
                backgroundColor: '#000000',
            },
        },
        {
            selector: '.back-button-selector',
            content: 'Return to your projects.',
            style: {
                backgroundColor: '#000000',
            },
        },
    ];

    useEffect(() => {
        reloadProject();
    }, []);

    const reloadProject = async () => {
        let id = window.location.href.split('/').pop();
        if (id && id.length === 24) {
            await projectService.get(id)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        Swal.close();
                        return;
                    }

                    if (result.data.length === 1) {
                        loadProject(result.data[0]);
                        
                        if(result.data[0].tabs && result.data[0].tabs.length > 0) {
                            setActiveTabId(result.data[0].tabs[0]._id);
                            if(document.querySelector(`.btn-tab`)) {
                                document.querySelector(`.btn-tab`).click();
                            }
                        }
                    }
                });
        }
    }

    const loadProject = project => {
        // setTitle(project.title);
        setProject(project);
        if (project.moodboards.length == 0) {
            setIsTourOpen(true)
        }
        setMoodboardOrder(project.moodboards.length + 1);
        const el = document.getElementById('txt-project-title');
        el.style.display = 'block';
        el.value = project.title;
        el.focus();
        el.removeAttribute('readonly');
        if (project.userId._id !== session.get('user')._id) {
            el.setAttribute('readonly', 'readonly');
        }
    }

    const saveMoodboards = async (arr, projectId, tabId) => {
        return new Promise(async (resolve, reject) => {
            for (let i = 0; i < arr.length; i++) {
                const k = arr[i];
                await moodboardService.add({
                    order: k.order,
                    title: k.title,
                    description: k.description,
                    type: k.type,
                    projectId: projectId,
                    tabId: tabId,
                    fileUrl: k.url,
                    thumbnailUrl: k.thumbnailUrl || null,
                    fileName: null,
                    fileSize: 0,
                    fileKey: null,
                    userId: session.get('user').id,
                    date: moment().format()
                });
            }
            resolve(true);
        });
    }

    const deleteItem = id => {
        swalDeleteForm(async () => {
            await moodboardService.delete(id)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        return;
                    }
                    // reloadProject();
                    reloadMoodboards(activeTabId);
                });
        });
    }

    const viewItem = id => {
        if (id) {
            tabMoodboards.forEach((x, idx) => {
                if (x._id === id) {
                    setViewCommentsFor(idx + 1);
                }
            });
        }
    }

    const uploadMoodboards = async (arr, projectId, tabId) => {
        return new Promise(async (resolve, reject) => {
            for (let i = 0; i < arr.length; i++) {
                const k = arr[i];
                await moodboardService.uploadWithProgress({
                    order: k.order,
                    title: k.title,
                    description: k.description,
                    type: k.type,
                    projectId: projectId,
                    tabId: tabId,
                    file: k.file,
                    userId: session.get('user').id,
                    date: moment().format()
                }, percent => {
                    console.log("precision: " + percent);
                    setProgress(percent);
                });
            }
            resolve(true);
        });
    }

    const uploadMoodboardsToS3 = async (arr, projectId, tabId) => {
        return new Promise(async (resolve, reject) => {
            for (let i = 0; i < arr.length; i++) {
                let k = arr[i];
                let ext = k.file.name.split(".").pop();
                let key = `${uuid()}.${ext}`;

                document.getElementById('swal2-title').innerHTML = `Uploading ${arr.length} files...<br/> ${0}%`;
                document.getElementById('swal2-content').innerHTML = `File ${i+1}/${arr.length} : ${k.file.name}`;
                let target = {
                    Bucket: process.env.REACT_APP_S3_BUCKET,
                    Key: key,
                    Body: k.file,
                    ACL: process.env.REACT_APP_S3_PERMISSIONS
                };
                let parallelUploads3 = new Upload({
                    client: new S3Client({
                        region: process.env.REACT_APP_S3_REGION,
                        credentials: {
                            accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
                            secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
                        }
                    }),
                    leavePartsOnError: false,
                    params: target,
                });

                parallelUploads3.on("httpUploadProgress", progress => {
                    console.log(progress);
                    let percent = parseFloat((progress.loaded / progress.total) * 100).toFixed(2);
                    document.getElementById('swal2-title').innerHTML = `Uploading ${arr.length} files...<br/> ${percent}%`;
                });

                await parallelUploads3.done();

                await moodboardService.saveAsIs({
                    order: k.order,
                    title: k.title,
                    description: k.description,
                    type: k.type,
                    projectId: projectId,
                    tabId: tabId,
                    userId: session.get('user').id,
                    date: moment().format(),
                    fileName: k.file.name,
                    fileKey: key,
                    fileSize: k.file.size,
                    fileUrl: `${process.env.REACT_APP_S3_BUCKET_ADDRESS}${key}`
                });
            }

            resolve(true);
        });
    }

    const onSelectPexels = async data => {
        swalUploading();
        let f = [];
        let order = moodboardOrder;
        data.photos.forEach(x => {
            f.push({
                type: 'image',
                url: x.link,
                thumbnailUrl: x.thumbnailUrl,
                title: ``,
                description: ``,
                order: order
            });
            order += 1;
        });

        data.videos.forEach(v => {
            f.push({
                type: 'pexels-video',
                url: v.link,
                thumbnailUrl: v.thumbnailUrl,
                title: ``,
                description: ``,
                order: order
            });
            order += 1;
        });

        setMoodboardOrder(order + 1);
        await saveMoodboards(f, project._id, activeTabId);

        if(project.moodboards.length === 0)
            reloadProject();
        else
            reloadMoodboards(activeTabId);

        Swal.close();
    }

    const onSelectEmbed = async (url, type) => {
        let t = [];
        swalUploading();
        let order = moodboardOrder;
        t.push({
            type: type,
            url: url,
            title: ``,
            description: ``,
            order: order
        });
        setMoodboardOrder(order + 1);
        await saveMoodboards(t, project._id, activeTabId);

        if(project.moodboards.length === 0)
            reloadProject();
        else
            reloadMoodboards(activeTabId);

        Swal.close();
    }

    const onSelectWebsite = async obj => {
        let t = [];
        swalUploading();
        let order = moodboardOrder;
        t.push({
            type: obj.type,
            url: obj.url,
            title: obj.title,
            description: obj.description,
            order: order
        });
        setMoodboardOrder(order + 1);
        await saveMoodboards(t, project._id, activeTabId);

        if(project.moodboards.length === 0)
            reloadProject();
        else
            reloadMoodboards(activeTabId);

        Swal.close();
    }

    const onSelectEmbedInstagram = async (url, type) => {
        // let t = [];
        // swalUploading();
        // let order = moodboardOrder;
        // t.push({
        //     type: type,
        //     url: url,
        //     title: ``,
        //     description: ``,
        //     order: order
        // });
        // setMoodboardOrder(order + 1);
        // await saveMoodboards(t, project._id, activeTabId);

        // if(project.moodboards.length === 0)
        //     reloadProject();
        // else
        //     reloadMoodboards(activeTabId);

        // Swal.close();
    }

    const handleCancel = e => {
        e.preventDefault();
        let t = document.getElementById('txt-project-title').value || ``;
        if ((tabMoodboards && tabMoodboards.length === 0) && t.length === 0) {
            swalConfirm(async () => {
                const id = window.location.href.split('/').pop();
                await projectService.delete(id);
                setRedirectTo(`/`);
            });
        } else {
            setRedirectTo(`/`);
        }
    }

    const changeView = (e, type) => {
        e.preventDefault();
        document.querySelectorAll('.display-options svg').forEach(i => i.classList.remove('text-white'));
        document.querySelector(`.display-options .${type}`).classList.add('text-white');
        setDisplayType(type);
        reloadProject();
    }

    const getFileType = type => {
        if (type.includes('image'))
            return 'image';
        if (type.includes('audio'))
            return 'audio';
        if (type.includes('video'))
            return 'video';
    }

    /*
    Commented out file uploading via Server code
     */
    // const handleUploadSelectedFiles = async e => {
    //     const files = e.target.files;
    //     const moodboardFiles = [];
    //     let order = 1;
    //     for (let i = 0; i < files.length; i++) {
    //         let file = files[i];
    //         order = moodboardOrder;
    //         let type = getFileType(file.type);
    //         moodboardFiles.push({
    //             type: type,
    //             file: file,
    //             title: file.name,
    //             description: ``,
    //             order: order
    //         });
    //         order += 1;
    //     }
    //
    //     swalUploadingWithProgress(progress);
    //     setMoodboardOrder(order);
    //     await uploadMoodboards(moodboardFiles, project._id, activeTabId);
    //
    //     if(project.moodboards.length === 0)
    //         reloadProject();
    //     else
    //         reloadMoodboards(activeTabId);
    //
    //     Swal.close();
    // }

    const handleUploadSelectedFiles = async e => {
        const files = e.target.files;
        if(files.length === 0) return;

        swalUploadingWithProgress(files.length);

        const moodboardFiles = [];
        let order = 1;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            order = moodboardOrder;
            let type = getFileType(file.type);
            moodboardFiles.push({
                type: type,
                file: file,
                title: file.name,
                description: ``,
                order: order
            });
            order += 1;
        }

        setMoodboardOrder(order);
        await uploadMoodboardsToS3(moodboardFiles, project._id, activeTabId);

        if(project.moodboards.length === 0)
            reloadProject();
        else
            reloadMoodboards(activeTabId);

        Swal.close();
    }

    const checkIfUserOrCollaborator = e => {
        const userID = session.get('user')._id
        if (project.userId._id === userID) {
            return true;
        }
        for (var i in project.collaborations) {
            if (i.id && i._id === userID) {
                return true;
            }
        }

        return false;
    }

    const checkIfUserCanEdit = e => {
        const userID = session.get('user')._id;
        if (project.userId._id === userID) {
            return true;
        }
        for (var i in project.collaborations) {
            if (i._id === userID && i.type === 2) {
                return true;
            }
        }
        return false;
    }

    const allowCollaborate = () => {
        if(project) {
            const loggedInUserId = session.get('user')._id;
            const loggedInUserEmail = session.get('user').email;
            if(!loggedInUserId || !loggedInUserEmail) {
                return false;
            }

            if (project.userId._id.toString() === loggedInUserId.toString()) {
                return true;
            }

            const collaboration = project.collaborations.find(k => k.email === loggedInUserEmail);
            if(collaboration) {
                if(parseInt(collaboration.accepted) === 1 && parseInt(collaboration.type) === 2) {
                    return true;
                }
            }

            return false;
        }
    }

    const handleAddTab = async e => {
        e.preventDefault();
        let max = project.tabs && project.tabs.length;
        let obj = {
            title: `Tab ${max+1}`,
            date: moment().format(),
            projectId: project._id
        };

        tabService.add(obj)
            .then(result => {
                if (result.data) {
                    reloadProject();
                }
            });
    }

    const reloadMoodboards = async tabId => {
        tabService.get(tabId)
            .then(result => {
                if (result.data) {
                    setTabMoodboards(result.data[0].moodboards);
                }
            });
    }

    const handleTabClick = e => {
        document.querySelectorAll(`.btn-tab`).forEach(t => t.classList.remove('tab-active'));
        e.target.classList.add('tab-active');
        let id = e.target.getAttribute('id');
        setActiveTabId(id);
        reloadMoodboards(id);
        if (displayType === 'list') {
            setTimeout(() => {
                if (document.querySelector('.thumbs .video-thumbnail')) {
                    document.querySelector('.thumbs .video-thumbnail').click();
                }
            }, 500);
        }
    }

    const handleDeleteTab = (e, tabId) => {
        e.preventDefault();
        swalDeleteForm(async () => {
            await tabService.delete(tabId)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        return;
                    }
                    reloadProject();
                });
        });
    }

    const handleRenameTab = (e, title, id) => {
        e.preventDefault();
        swalRenameTab(title, newTitle => {
            let obj = {
                title: newTitle,
                id: id
            };
            tabService.update(obj)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        return;
                    }
                    reloadProject();
                });
        });
    }

    const renderTabs = () => {
        if (project && project.tabs.length > 0) {
            return (
                <div className="btn-group text-center" role="group">
                    {
                        project.tabs.map(t =>
                            <div key={t._id} className="btn-tab-container">
                                <button
                                    id={t._id}
                                    type="button"
                                    className="btn btn-sm btn-tab"
                                    onClick={handleTabClick}
                                    onDoubleClick={e => handleRenameTab(e, t. title, t._id)}
                                >
                                    {t.title}
                                    <ClearIcon
                                        className="btn-delete-tab"
                                        id={t._id}
                                        onClick={e => handleDeleteTab(e, t._id)}
                                    />
                                </button>
                            </div>
                        )
                    }
                </div>
            );
        }
    }

    const renderCollaborators = () => {
        if (project && project.collaborationusers.length > 0) {
            return project.collaborationusers.map(t =>
                <Avatar
                    key={t._id}
                    style={{margin: '2px'}}
                    size={30}
                    round={true}
                    name={t.fullname}
                    maxInitials={2}
                    color="#7380A1"
                />
            )
        }
    }

    return (
        <div className="container-fluid" style={{ padding: '0px' }}>
            {redirectTo && <Redirect push to={redirectTo} />}
            {showPexels && <Pexels onClose={() => setShowPexels(false)} onSelect={onSelectPexels} />}
            {showEmbed && <Embed onClose={() => setShowEmbed(false)} onSelect={onSelectEmbed} />}
            {showWebsite && <EmbedWebsite onClose={() => setShowWebsite(false)} onSelect={onSelectWebsite} />}
            {showEmbedInstagram && <EmbedInstagram onClose={() => setShowEmbedInstagram(false)} onSelect={onSelectEmbedInstagram} />}
            {showCollaborate && project && <Collaborate onClose={() => setShowCollaborate(false)} projectId={project._id} project={project} />}
            {viewCommentsFor && <ContentDetails selectedIndex={viewCommentsFor} data={tabMoodboards} onClose={() => setViewCommentsFor(null)} />}

            {/*<input type="text" className="form-control txt-project-title" id="txt-project-title" placeholder="Project Title"*/}
            {/*    value={title} onChange={e => setTitle(e.target.value)} onBlur={updateTitle} />*/}

            {/*<Tour
                steps={steps}
                isOpen={isTourOpen}
                onRequestClose={() => setIsTourOpen(false)}
            />*/}
            {
                project && project.moodboards.length == 0 &&
                <div className="display-options">
                    <KeyboardBackspaceIcon className="material-svg back-button-selector" style={{ marginRight: '10px' }} onClick={handleCancel} title="Back to dashboard" />
                </div>
            }
            {
                project && project.moodboards.length > 0 &&
                <>
                    <BrowserView>
                        <div className="display-options">
                        <div className="row">
                            <div className="col-2 text-left change-view-btns">
                                <KeyboardBackspaceIcon className="material-svg back-button-selector"
                                                       style={{marginRight: '10px'}} onClick={handleCancel}
                                                       title="Back to dashboard"/>
                                <ViewModuleOutlinedIcon className="material-svg grid text-white" id="gridButton"
                                                        onClick={e => changeView(e, 'grid')}/>
                                <ViewListOutlinedIcon className="material-svg list " onClick={e => changeView(e, 'list')}/>
                            </div>
                            <div className="col-6 text-center tabs">
                                {renderTabs()}
                            </div>
                            <div className="col-4 text-right pm">
                                {renderCollaborators()}
                                {
                                    allowCollaborate() &&
                                    <>
                                        <button style={{marginLeft: '10px'}}
                                                className="btn share-button-selector btn-share"
                                                onClick={() => setShowCollaborate(true)} title="Share">Share
                                        </button>
                                        <div className="btn-group">
                                            <div className="dropdown" style={{width: '80px'}}>
                                                <button className="btn dropdown-toggle btn-new-2" type="button"
                                                        id="dropdownMenuButton" data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false">
                                                    New
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-right"
                                                     aria-labelledby="dropdownMenuButton">
                                                    <a className="dropdown-item" onClick={e => setShowPexels(true)}>
                                                        <AddPhotoAlternateIcon/> Add Stock
                                                    </a>
                                                    <a className="dropdown-item" onClick={e => setShowEmbed(true)}>
                                                        <VideoLibraryIcon/> Embed
                                                    </a>
                                                    <a className="dropdown-item"
                                                       onClick={e => document.getElementById('txt-selected-files').click()}>
                                                        <InsertDriveFileIcon/> Upload Files
                                                    </a>
                                                    <a className="dropdown-item" onClick={e => setShowWebsite(true)}>
                                                        <WebIcon/> Add Website
                                                    </a>
                                                    {/*<a className="dropdown-item" onClick={e => setShowEmbedInstagram(true)}>*/}
                                                    {/*    <InstagramIcon /> Add Instagram*/}
                                                    {/*</a>*/}
                                                    <a className="dropdown-item" onClick={handleAddTab}>
                                                        <TabIcon/> Add New Tab
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        </div>
                    </BrowserView>
                    <MobileView>
                        <div className="display-options">
                        <div className="row">
                            <div className="col-5 text-left change-view-btns">
                                <KeyboardBackspaceIcon className="material-svg back-button-selector"
                                                       style={{marginRight: '10px'}} onClick={handleCancel}
                                                       title="Back to dashboard"/>
                                <ViewModuleOutlinedIcon className="material-svg grid text-white" id="gridButton"
                                                        onClick={e => changeView(e, 'grid')}/>
                                <ViewListOutlinedIcon className="material-svg list " onClick={e => changeView(e, 'list')}/>
                            </div>
                            <div className="col-7 text-right pm">
                                {renderCollaborators()}
                                {
                                    allowCollaborate() &&
                                    <>
                                        <button style={{marginLeft: '10px'}}
                                                className="btn share-button-selector btn-share"
                                                onClick={() => setShowCollaborate(true)} title="Share">Share
                                        </button>
                                        <div className="btn-group" style={{marginRight: '10px'}}>
                                            <div className="dropdown" style={{width: '80px'}}>
                                                <button className="btn dropdown-toggle btn-new-2" type="button"
                                                        id="dropdownMenuButton" data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false">
                                                    New
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-right"
                                                     aria-labelledby="dropdownMenuButton">
                                                    <a className="dropdown-item" onClick={e => setShowPexels(true)}>
                                                        <AddPhotoAlternateIcon/> Add Stock
                                                    </a>
                                                    <a className="dropdown-item" onClick={e => setShowEmbed(true)}>
                                                        <VideoLibraryIcon/> Embed
                                                    </a>
                                                    <a className="dropdown-item"
                                                       onClick={e => document.getElementById('txt-selected-files').click()}>
                                                        <InsertDriveFileIcon/> Upload Files
                                                    </a>
                                                    <a className="dropdown-item" onClick={e => setShowWebsite(true)}>
                                                        <WebIcon/> Add Website
                                                    </a>
                                                    {/*<a className="dropdown-item" onClick={e => setShowEmbedInstagram(true)}>*/}
                                                    {/*    <InstagramIcon /> Add Instagram*/}
                                                    {/*</a>*/}
                                                    <a className="dropdown-item" onClick={handleAddTab}>
                                                        <TabIcon/> Add New Tab
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="row mt-10">
                            <div className="col text-center tabs">
                                {renderTabs()}
                            </div>
                        </div>
                        </div>
                    </MobileView>
                </>
            }
            {
                tabMoodboards && displayType === 'grid' &&
                <div className="moodboard-tiles text-center mt-20" id="moodboard-tiles">
                    <MoodboardTiles moodboards={tabMoodboards} delete={deleteItem} view={viewItem} />
                </div>
            }
            {/*
                project && project.moodboards.length > 0 && displayType === 'masonry' &&
                <MoodboardMasonry moodboards={project.moodboards} delete={deleteItem} /> /
            */}
            {
                tabMoodboards && displayType === 'list' &&
                <MoodboardMediaView moodboards={tabMoodboards} />
            }

            <input
                id="txt-selected-files"
                type="file"
                style={{ display: 'none' }}
                accept=".jpg,.jpeg,.png,.mp4,.mp3"
                multiple
                onChange={handleUploadSelectedFiles}
            />

            {project && project.moodboards.length === 0 &&
                <div className="default-project-container text-center container action-button-selector">
                    <div className="default-project-button" onClick={() => {
                        // setIsOpen(!isOpen)
                        setShowPexels(true)
                    }}><AddPhotoAlternateIcon /> Add Stock
                    </div>
                    <div className="default-project-button" onClick={() => {
                        // setIsOpen(!isOpen)
                        document.getElementById('txt-selected-files').click()
                    }}>
                        <InsertDriveFileIcon /> Upload Files
                    </div>
                    <div className="default-project-button" onClick={() => {
                        // setIsOpen(!isOpen)
                        setShowEmbed(true)
                    }}>
                        <VideoLibraryIcon /> Embed
                    </div>
                    <div className="default-project-button" onClick={() => {
                        // setIsOpen(!isOpen)
                        setShowWebsite(true)
                    }}>
                        <WebIcon /> Add Website
                    </div>
                </div>
            }

            {/*{project && project.moodboards.length > 0 && checkIfUserCanEdit() &&*/}
            {/*    <FloatingMenu*/}
            {/*        slideSpeed={500}*/}
            {/*        direction="up"*/}
            {/*        spacing={8}*/}
            {/*        isOpen={isOpen}*/}
            {/*        style={{ position: 'fixed', bottom: '5vh', right: '2vh' }}*/}
            {/*    >*/}
            {/*        <MainButton*/}
            {/*            iconResting={<div><MdAdd /> Add Media</div>}*/}
            {/*            iconActive={<MdClose />}*/}
            {/*            backgroundColor="black"*/}
            {/*            onClick={() => setIsOpen(!isOpen)}*/}
            {/*            size={45}*/}
            {/*            className="btn-floating-child"*/}
            {/*            title="Add photos, videos and files."*/}
            {/*        />*/}
            {/*        <ChildButton*/}
            {/*            icon={<div><VideoLibraryIcon /> Embed   </div>}*/}
            {/*            size={40}*/}
            {/*            className="btn-floating-child"*/}
            {/*            onClick={() => {*/}
            {/*                setIsOpen(!isOpen)*/}
            {/*                setShowEmbed(true)*/}
            {/*            }}*/}
            {/*            title="Embed YouTube/Vimeo videos."*/}
            {/*        />*/}
            {/*        <ChildButton*/}
            {/*            icon={<div><InsertDriveFileIcon /> Upload Files </div>}*/}
            {/*            className="btn-floating-child"*/}
            {/*            size={40}*/}
            {/*            onClick={() => {*/}
            {/*                setIsOpen(!isOpen)*/}
            {/*                document.getElementById('txt-selected-files').click()*/}
            {/*            }}*/}
            {/*            title="Upload audio/photos files from your computer."*/}
            {/*        />*/}
            {/*        <ChildButton*/}
            {/*            icon={<div> <AddPhotoAlternateIcon /> Add Stock </div>}*/}
            {/*            className="btn-floating-child"*/}
            {/*            size={40}*/}
            {/*            onClick={() => {*/}
            {/*                setIsOpen(!isOpen)*/}
            {/*                setShowPexels(true)*/}
            {/*            }}*/}
            {/*            title="Add photos/videos directly from Pexels."*/}
            {/*        />*/}
            {/*        <ChildButton*/}
            {/*            icon={<div> <InstagramIcon /> Add Instagram </div>}*/}
            {/*            className="btn-floating-child"*/}
            {/*            size={40}*/}
            {/*            onClick={() => {*/}
            {/*                setIsOpen(!isOpen)*/}
            {/*                setShowEmbedInstagram(true)*/}
            {/*            }}*/}
            {/*            title="Add photos/videos directly from Instagram."*/}
            {/*        />*/}
            {/*    </FloatingMenu>}*/}
        </div>
    );
}